import { render, staticRenderFns } from "./SlideDeckControls.vue?vue&type=template&id=60760168&"
import script from "./SlideDeckControls.vue?vue&type=script&lang=js&"
export * from "./SlideDeckControls.vue?vue&type=script&lang=js&"
import style0 from "./SlideDeckControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports